import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.einlasskontrolle-benutzer-zugriff';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleEinlasskontrolleBenutzerZugriffEffects {

    EinlasskontrolleBenutzerZugriff$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_EINLASSKONTROLLE_BENUTZER_ZUGRIFF),
        mergeMap((x: ac.GetEinlasskontrolleBenutzerZugriffAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getEinlasskontrolleBenutzerZugriff().pipe(
                map((result: any) => {
                    return new ac.GetEinlasskontrolleBenutzerZugriffErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetEinlasskontrolleBenutzerZugriffFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleQueryService);
        }
        return this.service;
    }
}
